import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { MatDialog } from '@angular/material/dialog';
import { PopupMessagesComponent } from '../popup-messages/popup-messages.component';
import { Message } from '../../_models/Message';
import { ProtocoloFiscalComponent } from 'src/app/_pages/protocolo-fiscal/protocolo-fiscal.component';
import { PopupMessagesNewStyleTestComponent } from '../popup-messages-new-style-test/popup-messages-new-style-test.component';

@Component({
  selector: 'app-upload-fiscal',
  templateUrl: './upload-fiscal.component.html',
  styleUrls: ['./upload-fiscal.component.css']
})
export class UploadFiscalComponent implements OnInit {
  @ViewChild('file', { static: true }) file: ElementRef;
  public progress: number;
  public message: string;
  formData: FormData;
  mineTypes: string[] = ['image/gif', 'image/png', 'image/jpeg', 'application/pdf', 'image/tiff'];
  mineXmlTypes: string[] = ['image/gif', 'image/png', 'image/jpeg', 'application/pdf', 'image/tiff', 'text/xml'];

  constructor(private http: HttpClient,
    public protocoloFiscalComponent: ProtocoloFiscalComponent,
    private dialog?: MatDialog) {
    this.formData = new FormData();
  }

  loadFiles() {
    const files = this.file.nativeElement.files;
    if (files.length === 0) {
      return;
    }

    let qtdXml = 0;
    for (const file of files) {
      if (file.name.substr(-4).toUpperCase() === '.XML') {
        qtdXml++;
      }
    }
    this.protocoloFiscalComponent.LstUploadFiles.forEach(element => {
      if (element.substr(-4).toUpperCase() === '.XML') {
        qtdXml++;
      }
    });

    for (const file of files) {
      const mine = this.mineTypes.find(c => c === file.type) || '';
      const mineXml = this.mineXmlTypes.find(c => c === file.type) || '';
      const currentTipoDocumento = JSON.parse(localStorage.getItem('codTipoDocumento'));

      if (currentTipoDocumento === 20 && !mineXml) {
        const msg = new Message('Atenção'
          // tslint:disable-next-line:max-line-length
          , 'A imagem do documento deve estar nos formatos ".png", "gif", ".tif", ".jpg", ".pdf" ou ".xml"'
          , ''
          , 'error');
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: msg });
        (<HTMLInputElement>document.getElementById('frmFile')).value = null;
        return;
      } else if (currentTipoDocumento === 20 && qtdXml > 1) {
        const msg = new Message('Atenção', 'É permitido a inserção de apenas um arquivo ".xml".', '', 'error');
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: msg });
        (<HTMLInputElement>document.getElementById('frmFile')).value = null;
        return;
      } else if (!mine && currentTipoDocumento !== 20) {
        const msg = new Message('Atenção'
          , 'A imagem do documento deve estar nos formatos ".png", "gif", ".tif", ".jpg" ou ".pdf"', '', 'error');
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: msg });
        (<HTMLInputElement>document.getElementById('frmFile')).value = null;
        return;
      }

      this.formData.append(file.name, file);
      this.protocoloFiscalComponent.FormDataUpload.append(file.name, file);
      this.protocoloFiscalComponent.LstUploadFiles.push(file.name);
    }
    (<HTMLInputElement>document.getElementById('frmFile')).value = null;
  }

  removeFile(fileParam) {
    for (const file of this.file.nativeElement.files) {
      if (file.name === fileParam.name) {
        this.file.nativeElement.files = this.file.nativeElement.files.filter(obj => obj !== fileParam);
      }
    }
  }

  ngOnInit() {
  }
}
